import { atom } from "jotai";
import { getallactivities, getbomlists, getBomperTrackerType, getCheckListData, getCheckLists, getCpCheckList, getSvgData, getTypeDatas } from "../../services/setup/service";
import { getActivities, getConstructionProgress, getPierLegends } from "../../services/dashboard/index";
import { getAllConstructionSequence } from "../../services/construction/constructionSequenceService";

const setupAtoms = atom({
    cpChecklist: [],  
    qcChecklist: [],
    bomList: [],
    activityList: {},
    constructionList: {},
    progressList: [],
    checklistValue: {},
    typeData: {},
    checklistData: {},
    pierLegends: {},
    SvgData: {},
    constructionSequences: [],
    bompertrackertypeData : {}
});

export const getBomData = atom(null, async (_, set, _args) => {
  const res = await getBomperTrackerType()
set(setupAtoms, (prev) => ({ ...prev, bompertrackertypeData: res?.data }));
});

export const getcpChecklist = atom(null, async (_, set, _args) => {
    const res = await getCpCheckList()
  set(setupAtoms, (prev) => ({ ...prev, cpChecklist: res?.data })); 
});

export const getChecklist = atom(null, async (_, set, args) => {
  const res = await getCheckLists(args)
set(setupAtoms, (prev) => ({ ...prev, checklistValue: res?.data })); 
});

export const fetchActivityList = atom(null, async (_, set, _args) => {
  const res = await getallactivities()
set(setupAtoms, (prev) => ({ ...prev, activityList: res?.data })); 
});


export const fetchbomdetails = atom(
  null,
  async (get, set, args) => {
      const res = await getbomlists();
      if(res) {
          set(setupAtoms, (prev) => ({ ...prev, bomList: res?.data }));
      }
  }
)

export const getActivity = atom(null, async (_, set, _args) => {
  const res = await getActivities()
if (res) {
  set(setupAtoms, (prev) => ({ ...prev, constructionList: res.data }));
}
});


export const getConstructionProgressList = atom(null, async (_, set, _args) => {
  const res = await getConstructionProgress();
if (res) {
  set(setupAtoms, (prev) => ({ ...prev, progressList: res.data }));
}
});


export const fetchTypeData = atom(null, async (_, set, _args) => {
  const res = await getTypeDatas();
if (res) {
  set(setupAtoms, (prev) => ({ ...prev, typeData: res.data }));
}
});


export const fetchChecklistData = atom(null, async (_, set, _args) => {
  const res = await getCheckListData();
if (res) {
  set(setupAtoms, (prev) => ({ ...prev, checklistData: res.data }));
}
});

export const fetchPierLegends = atom(null, async (_, set, _args) => {
  const res = await getPierLegends();
  if (res) {
    set(setupAtoms, (prev) => ({ ...prev, pierLegends: res.data }));
  }
});


export const fetchtrackertypeData = atom(null, async (_, set, args) => {
  const res = await getSvgData(args);
  if (res) {
    set(setupAtoms, (prev) => ({ ...prev, SvgData: res.data }));
  }
});

export const fetchConstructionSequences = atom(null, async (_, set, _args) => {
    const res = await getAllConstructionSequence();
    if (res) {
        set(setupAtoms, (prev) => ({ ...prev, constructionSequences: res }));
    }
});

export default setupAtoms;
